export type ILocaleMessage = {
  [key: string]: string | ILocaleMessage;
};

/*
  Get language that is available on ContentStack.
  Due to frontend / business requirement change, language shown to the users
  may not be available on ContentStack.
*/
export const getContentStackLang = (locale: string) => {
  if (!locale) {
    return 'en';
  }

  return locale.toLocaleLowerCase();
};

export const getQRLang = (locale) => {
  if (locale === 'es-AR' || locale === 'es-MX') {
    return 'es-ES';
  }

  return locale;
};
